/* @generated */
import * as React from "react";
const defaultValue = {};
export const IconContext = React.createContext(defaultValue);
